import Breadcrumbs from './Breadcrumbs';
import { BreadcrumbType } from './Breadcrumbs.types';

export default Breadcrumbs;

export type { BreadcrumbType };
